import { FC } from 'react';
import { mergeClasses } from 'shared/utils/mergeClasses';

type ExternalLinkVariant = 'gray' | 'primary' | 'light-gray';
interface ExternalLinkProps {
  href: string;
  text: string;
  variant: ExternalLinkVariant;
  disabled?: boolean;
  className?: string;
}

const mapVariantToColor = (variant: ExternalLinkVariant): string => {
  switch (variant) {
    case 'primary':
      return 'primary';
    case 'gray':
      return 'gray';
    case 'light-gray':
      return 'gray-400';
    default:
      return 'primary';
  }
};

export const ExternalLink: FC<ExternalLinkProps> = ({
  href,
  text,
  variant,
  disabled = 'false',
  className = '',
}) => {
  return (
    <a
      className={mergeClasses(
        `text-${mapVariantToColor(variant)} ${disabled ? 'hover:underline' : ''}`,
        className,
      )}
      href={href}
      rel="noreferrer"
      target="_blank"
    >
      {text}
    </a>
  );
};
